<template>
    <b-container>
        <b-form @submit.prevent="onSubmit" class="edit_form">
            <button-row :Buttons="Buttons"></button-row>
            <b-row class="mt-4 mb-3">
                <b-col>
                    <h3 class="mb-1">Allgemein</h3>
                </b-col>
            </b-row>
            <b-row >
                <b-col cols="6">
                    <b-form-group
                            id="input-group-salutation"
                            label="Anrede"
                            label-for="input-salutation"
                    >
                        <b-form-select
                                id="input-salutation"
                                required
                                v-model="edit_user.fe_user_salutation"
                                :options="salutationOptions"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col cols="6 ">
                    <b-form-group
                            id="input-group-title"
                            label="Titel"
                            label-for="input-title"
                    >
                        <b-form-input
                                id="input-title"
                                v-model="edit_user.fe_user_title"
                                placeholder=""
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="6">
                    <b-form-group
                        id="input-group-firstname"
                        label="Vorname"
                        label-for="input-firstname"
                    >   
                        <b-form-input
                            id="input-firstname"
                            v-model="edit_user.fe_user_firstname"
                            required
                            placeholder="Vorname"
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group
                        id="input-group-lastname"
                        label="Nachname"
                        label-for="input-lastname"
                    >   
                        <b-form-input
                            id="input-lastname"
                            v-model="edit_user.fe_user_lastname"
                            required
                            placeholder="Nachname"
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group
                        id="input-group-birthday"
                        label="Geburtsdatum"
                        label-for="input-birthday"
                    >   
                        <b-form-input
                            type="date"
                            id="input-birthday"
                            v-model="edit_user.fe_user_birthday_date"
                            placeholder="Geburtstag"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <div class="user_img" :style="edit_user.fe_user_photo ? {backgroundImage: `url(${encodeURI(edit_user.fe_user_photo.sizes.Preview)})`} : ''">
                        <b-form-file
                        v-if="this.user_id"
                        v-model="user_img"
                        :state="Boolean(user_img)"
                        placeholder="Bild tauschen"
                        ref="file-input"
                        id="user_img"
                        name="user_img"
                        ></b-form-file>
                    </div>
                        <!-- <div class="mt-3">Selected file: {{ file ? file.name : '' }}</div> -->
                </b-col>
            </b-row>
            <b-row class="mb-3">
                <b-col><h3 class="mb-1">Kontaktdaten</h3></b-col>
            </b-row>
            <b-row >
                <b-col>
                    <b-form-group
                        id="input-group-emailp"
                        label="E-Mail-Adresse privat / Benutzername"
                        label-for="input-emailp"
                    >   
                        <b-form-input
                            type="email"
                            id="input-emailp"
                            required
                            v-model="edit_user.fe_user_email_private"
                            placeholder="E-Mail-Adresse privat"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row >
                <b-col>
                    <b-form-group
                        id="input-group-emailb"
                        label="E-Mail-Adresse geschäftlich"
                        label-for="input-emailb"
                    >   
                        <b-form-input
                            type="email"
                            id="input-emailb"
                            v-model="edit_user.fe_user_email_business"
                            placeholder="E-Mail-Adresse geschäftlich"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row >
                <b-col>
                    <b-form-group
                        id="input-group-phonep"
                        label="Telefon privat"
                        label-for="input-phonep"
                    >   
                        <b-form-input
                            type="tel"
                            id="input-phonep"
                            v-model="edit_user.fe_user_phone_private"
                            placeholder="Telefon privat"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row >
                <b-col>
                    <b-form-group
                        id="input-group-phoneb"
                        label="Telefon geschäftlich"
                        label-for="input-phoneb"
                    >   
                        <b-form-input
                            id="input-phoneb"
                            type="tel"
                            v-model="edit_user.fe_user_phone_business"
                            placeholder="Telefon geschäftlich"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row >
                <b-col>
                    <b-form-group
                        id="input-group-mobile"
                        label="Mobiltelefon"
                        label-for="input-mobile"
                    >   
                        <b-form-input
                            type="tel"
                            id="input-mobile"
                            v-model="edit_user.fe_user_mobile"
                            placeholder="Mobiltelefon"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row >
                <b-col>
                    <b-form-group
                        id="input-group-address"
                        label="Adresse"
                        label-for="input-address"
                    >   
                        <b-form-input
                            type="text"
                            id="input-address"
                            v-model="edit_user.fe_user_address"
                            placeholder="Straße"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="6">
                    <b-form-group
                        id="input-group-zip"
                        label="PLZ"
                        label-for="input-zip"
                    >   
                        <b-form-input
                            type="text"
                            id="input-zip"
                            v-model="edit_user.fe_user_zip"
                            placeholder="Postleitzahl"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group
                        id="input-group-city"
                        label="Ort"
                        label-for="input-city"
                    >   
                        <b-form-input
                            type="text"
                            id="input-city"
                            v-model="edit_user.fe_user_city"
                            placeholder="Ort"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <template v-if="isMemberAdmin">
                <b-row class="mb-3">
                    <b-col><h3 class="mb-1">Eigenschaften</h3></b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <b-form-group
                            id="input-group-active"
                            label-for="input-active"
                        >   
                            <b-form-checkbox
                                id="input-active"
                                v-model="edit_user.fe_user_active_bool"
                            >Aktiv</b-form-checkbox>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group
                            id="input-group-suspend"
                            label-for="input-suspend"
                        >   
                            <b-form-checkbox
                                id="input-suspend"
                                v-model="edit_user.fe_user_suspend_bool"
                            >Beurlaubt</b-form-checkbox>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group
                            id="input-group-guestmember"
                            label-for="input-guestmember"
                        >   
                            <b-form-checkbox
                                id="input-guestmember"
                                v-model="edit_user.fe_user_guestmember_bool"
                            >Gastmitglied</b-form-checkbox>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group
                            id="input-group-advantage"
                            label-for="input-advantage"
                        >   
                            <b-form-checkbox
                                id="input-advantage"
                                v-model="edit_user.fe_user_advantage_bool"
                            >Vorzugsmitglied</b-form-checkbox>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col><h3 class="mb-1">Amtsträger</h3></b-col>
                </b-row>
                <b-row>
                    <b-col cols="6"  v-for="(ur, ur_i) in user_roles" :key="ur_i">
                        <b-form-group
                            :id="`input-user-group-role-${ur_i}`"
                            :label-for="`input-user-role-${ur_i}`"
                        >   
                            <b-form-checkbox
                                :id="`input-user-role-${ur_i}`"
                                v-model="edit_user.fe_user_roles"
                                :value="ur.value"
                            >{{ur.text}}</b-form-checkbox>
                        </b-form-group>
                    </b-col>
                </b-row>
            </template>
            <button-row :Buttons="Buttons" comp_class="pt-4 border-top"></button-row>
        </b-form>
    </b-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ButtonRowVue from '../components/ButtonRow.vue';
export default {
    name: 'user-edit-cmp',
    components: {
        'button-row': ButtonRowVue,
    },
    props: {},
    data() {
        return {
            user_id: false,
            edit_user: { 
                fe_user_roles: [],
                fe_user_photo: null
            },
            salutationOptions: [
                { value: null, text: 'Bitte wählen' },
                { value: 'Frau', text: 'Frau' },
                { value: 'Herr', text: 'Herr' }
            ],
            user_img: null
        }
    },
    mounted() {
        this.fetchUserRoles();
        this.user_id = false;
        if (this.$route.params.Id != "false") {

            if(this.$route.name == 'my-profile') {
                this.user_id = this.getUserId;
            } else {
                this.user_id = this.$route.params.Id;
            }
        } else if (this.$route.name == 'my-profile') {
            this.user_id = this.getUserId;
        }

        if (typeof this.user_id == undefined || this.user_id == 'my-profile') {
            this.user_id = this.getUserId;
        }

        if (this.user_id == false && this.$route.params.Id == 'my-profile') {
            this.logout();
        }

        // this.user_id = this.$route.params.Id == "my-profile" ? localStorage.getItem('user_id') : false;
        // console.log(this.user_id, this.getUserId);
        this.init();
    },
    computed: {
        ...mapGetters('auth', ['loggedIn', 'isActivity', 'isMemberAdmin', 'getUserId']),
        ...mapGetters('events', ['user_roles']),
        ...mapGetters('members', ['fetching', 'member', 'uploading']),

        back_button_path() {
            return this.isMemberAdmin ? '/user-list' : '/';
        },

        Buttons() {
            const buttons = [];
            // if (this.$route.name != "my-profile") {
                buttons.push(
                    {
                        title: 'Zurück',
                        to: this.user_id !== false ? this.back_button_path : '/admin',
                        variant: 'light border',
                        icons: {
                            left: {
                                icon: ['far', 'arrow-left'],
                                visible: true
                            },
                            right: {
                                icon: ['far', 'arrow-right'],
                                visible: false
                            }
                        }
                    }
                );
            // }

            buttons.push({
                title: 'Speichern',
                variant: 'primary',
                type: 'submit',
                icons: {
                    left: {
                        icon: ['far', 'arrow-left'],
                        visible: false
                    },
                    right: {
                        icon: ['far', 'arrow-right'],
                        visible: false
                    }
                },
            });
            
            return buttons;
        }
    },
    watch: {
        user_img() {
            this.uploadFile();
        },
        fetching(newValue) {
            if (newValue == false) {
                this.edit_user = { ...this.member};
            }
        },
        uploading(newValue) {
            if (newValue == false) {
                // console.log(`set photo to ${this.member.fe_user_photo}`);
                this.edit_user.fe_user_photo = { ...this.member.fe_user_photo};
            }
        }
    },
    methods: {
        ...mapActions('members', ['fetchMember', 'saveMember', 'uploadUserImage']),
        ...mapActions('events', ['fetchUserRoles']),
        ...mapActions('auth', ['logout']),

        init() {
            // console.log(this.$route);
            if (this.user_id) {
                // console.log('fetch member', this.user_id);
                this.fetchMember(this.user_id);
            }
            this.addEventListener();
        },
        addEventListener() {
            window.LC_Event.$on('saveMemberSuccess', () => {
                
                this.$router.push(this.back_button_path);
                // this.fetchEvent(this.$route.params.Id);
            })
        },
        uploadFile() {
            this.file = this.$refs['file-input'].selectedFile;
            let formData = new FormData();
            formData.append('file', this.file);
            formData.append('member_id', this.user_id);
            

            // formData.append("action", "upload-attachment");

            // formData.append("async-upload", this.file);
            // formData.append("name", this.file.name);
                
            // //also available on page from _wpPluploadSettings.defaults.multipart_params._wpnonce
            // // <?php $my_nonce = wp_create_nonce('media-form'); ?>
            // // formData.append("_wpnonce", document.querySelector('#lc_nonce').dataset.nonce);
            // for (var p of formData) {
            //     console.log(p);
            // }

            this.uploadUserImage({data: formData});
        },
        onSubmit() {
            this.saveMember({data: this.edit_user})
        },
    }
}
</script>

<style lang="scss">
@import '../scss/variables';
    .custom-file-input ~ .custom-file-label::after {
        display: none !important
    }
    .custom-file {
        background: rgba($white, .75);
        position: absolute;
        bottom: 0;
        height: 40px;
    }
    .was-validated .custom-file-input ~ .custom-file-label, .custom-file-input ~ .custom-file-label {
        border: 0 !important;
        background-color: transparent;
        height: auto;
        padding: 9px 8px 7px;
        text-align: center;
        color: $primary;
        font-weight: $font-weight-bold;
        margin: 0
    }
    .user_img {
        margin-top: 29px;
        position: relative;
        border: 1px solid $primary;
        height: 240px;
        width: 100%;
        background-color: $info;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
    }

    .edit_form {
        /*
        .col-6 {
            padding-right: 7px;

            & + .col-6 {
                padding-right: ($grid-gutter-width/2);
                padding-left: 8px;
            }
        }
        */
    }

    .custom-select {
        padding-top: 12px;
        padding-bottom: 12px;
        height: auto;
    }
</style>